<template>
    <div class="home-video-banner grid grid__home">
        <div class="home-video-banner--wrap">
            <div v-if="video" class="home-video-banner--root">
                <img class="home-video-banner--img" :src="video.poster.url" :alt="video.poster.alt">

                <video v-if="isMobile" key="mobile-video" class="home-video-banner--video"
                        autoplay loop muted playsinline
                        :poster="video.poster.url"
                        :title="video.poster.alt">
                    <source :src="video.url">
                </video>

                <video v-else key="video" class="home-video-banner--video"
                        autoplay loop muted playsinline
                        :poster="video.poster.url"
                        :title="video.poster.alt">
                    <source :src="video.url">
                </video>
            </div>
            <div v-else class="home-video-banner--root">
                <img class="home-video-banner--image" :src="content.image.url" :alt="content.image.alt">
            </div>
        </div>

        <component :is="contentElementType" v-bind="linkProps" class="u-reset home-video-banner--content" :class="contentClasses">
            <div class="home-video-banner--container grid--container">
                <!-- <pre v-if="content" v-text="content"></pre> -->
                <h1 v-if="content.title" class="u-reset home-video-banner--title" :class="content.hide_title ? 'home-video-banner--title__is-hidden' : ''" v-html="content.title"></h1>
            </div>
        </component>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import cmsPlugin from 'vue/mixins/cms/cms-plugin';
    import bemMixin from 'vue/mixins/bem';
    import { toNumeral, numerals } from 'util/dom/mq';


    export default {
        mixins: [
            bemMixin('home-video-banner'),
            cmsPlugin,
        ],
        computed: {
            ...mapGetters(['viewport']),
            isMobile() {
                return toNumeral(this.viewport.mq.query) < numerals.MD;
            },
            contentElementType() {
                return this.content.href ? 'a' : 'div';
            },
            linkProps() {
                const attributes = {};
                if (this.content.href) {
                    attributes.href = this.content.href;
                }
                return attributes;
            },
            video() {
                return this.content[this.isMobile ? 'video_mobile' : 'video'];
            },
            contentClasses() {
                return [
                    this.bemAdd(this.content.href ? 'is-link' : '', 'content'),
                ];
            },
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?2d4d7791